// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".xZRD7cJ3eqExhoIvsDdTz{animation-duration:1s;animation-name:_1L8M0t7r7UmE24Bzg7PH5z;animation-iteration-count:infinite}@keyframes _1L8M0t7r7UmE24Bzg7PH5z{from{fill:#00000000;background-color:#00000000}to{fill:#e0e0e087;background-color:#e0e0e087}}.DZrPvkroZUXbY1UhPo2EM{animation-duration:1s;animation-name:_1UZozth3eXf0kHvLU8EuFR;animation-iteration-count:infinite;font-size:18px !important}@keyframes _1UZozth3eXf0kHvLU8EuFR{from{fill:black}to{fill:#00259e}}._3hdXyByJMArJa0irik6ELY{font-size:16px}\n", ""]);
// Exports
exports.locals = {
	"highlightElement": "xZRD7cJ3eqExhoIvsDdTz",
	"highlightAnimation": "_1L8M0t7r7UmE24Bzg7PH5z",
	"highlightText": "DZrPvkroZUXbY1UhPo2EM",
	"highlightTextAnimation": "_1UZozth3eXf0kHvLU8EuFR",
	"tutoAlert": "_3hdXyByJMArJa0irik6ELY"
};
module.exports = exports;
